import {Pipe, PipeTransform} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {HtmlSanitizerService} from '@core/services/html-sanitizer.service';

/**
 * Pipe for sanitizing HTML content in templates
 * Use this pipe with innerHTML binding to prevent XSS attacks
 *
 * Usage:
 *   <div [innerHTML]="userContent | sanitizeHtml"></div>
 */
@Pipe({
    name: 'sanitizeHtml',
    pure: true
})
export class SanitizeHtmlPipe implements PipeTransform {

    constructor(private htmlSanitizer: HtmlSanitizerService) {
    }

    transform(value: string, mode: 'html' | 'text' | 'user-content' = 'html'): SafeHtml | string {
        if (!value) {
            return '';
        }

        switch (mode) {
            case 'text':
                // Strip all HTML, return plain text
                return this.htmlSanitizer.stripAllHtml(value);

            case 'user-content':
                // Sanitize user-generated content (allows basic formatting)
                return this.htmlSanitizer.sanitizeUserContent(value);

            case 'html':
            default:
                // Sanitize HTML content
                return this.htmlSanitizer.sanitizeHtml(value);
        }
    }
}

